<!-- SECTION TITLE -->
<ion-row
  *ngIf="showTitle"
  data-cy="sortable-section-title-row"
  class="sortable-section-title-row ion-align-items-center"
>
  <ion-col data-cy="sortable-section-title-column" size="6" *ngIf="showTitle">
    <ion-label data-cy="sortable-section-title-text">
      {{ sectionTitle }}
    </ion-label>
  </ion-col>

  <ion-col data-cy="sortable-section-title-column" size="6">
    <ion-button
      *ngIf="
        (platformService?.isTouchExperience$ | async) && tabletHeaderButtonText
      "
      data-cy="sortable-section-header-button"
      class="usf-outline-green-button"
      (click)="handleHeaderButtonEvent($event)"
    >
      {{ tabletHeaderButtonText }}
      <ion-icon slot="end" name="chevron-down"></ion-icon>
    </ion-button>
  </ion-col>
</ion-row>

<!-- SECTION HEADERS (FOR SORTING) -->
<ion-row
  *ngIf="sectionHeaders"
  data-cy="sortable-section-header-row"
  class="sortable-section-header-row"
  [class.alternate-design]="alternateDesign"
>
  <ion-col
    *ngIf="showSelectAll && !nothingToSelect"
    [size]="
      platformService.platformEnum.tablet === platformService.platformType
        ? 0.3
        : 0.4
    "
    [offset]="
      platformService.platformEnum.tablet === platformService.platformType
        ? 0.2
        : 0.1
    "
  >
    <app-usf-checkbox
      [isSelected]="selectAllSelected"
      (selectEmitter)="selectAllClick()"
    ></app-usf-checkbox>
  </ion-col>
  <ion-col *ngIf="showSelectAll && nothingToSelect" size="0.4" offset="0.1">
  </ion-col>
  <ng-container
    *ngFor="let sectionHeader of sectionHeaders; index as i; trackBy: trackItem"
  >
    <ion-col
      *ngIf="sectionHeader?.displayText"
      [attr.data-cy]="
        'sortable-section-header-' +
        sectionHeader?.headerName?.toLowerCase() +
        '-column'
      "
      size="{{ sectionHeader?.size }}"
      offset="{{ sectionHeader?.offset }} "
    >
      <div
        [attr.data-cy]="
          'sortable-section-header-' +
          sectionHeader?.headerName?.toLowerCase() +
          '-section'
        "
        class="sortable-section-header-option"
        [class.sort-active]="selectedHeader === sectionHeader?.headerName"
        [class.dark-headers]="
          !!darkHeaders && selectedHeader !== sectionHeader?.headerName
        "
        [class.disabled-section-header-option]="
          disabledHeaders?.includes(sectionHeader)
        "
        (click)="handleUpdateSortEvent(sectionHeader)"
      >
        <p
          [attr.data-cy]="
            'sortable-section-header-' +
            sectionHeader?.headerName?.toLowerCase() +
            '-label'
          "
        >
          {{ sectionHeader?.displayText | translate }}
        </p>
        <div
          [attr.data-cy]="
            'sortable-section-header-' +
            sectionHeader?.headerName?.toLowerCase() +
            '-caret-section'
          "
          class="caret-icon"
        >
          <ion-icon
            *ngIf="
              (selectedHeader !== sectionHeader?.headerName &&
                sectionHeader?.sortDirection) ||
              (selectedHeader === sectionHeader?.headerName &&
                sectionHeader?.sortDirection === SortDirections.asc)
            "
            [attr.data-cy]="
              'sortable-section-header-' +
              sectionHeader?.headerName?.toLowerCase() +
              '-caret-up-icon'
            "
            name="caret-up-outline"
          ></ion-icon>
          <ion-icon
            *ngIf="
              (selectedHeader !== sectionHeader?.headerName &&
                sectionHeader?.sortDirection) ||
              (selectedHeader === sectionHeader?.headerName &&
                sectionHeader?.sortDirection === SortDirections.desc)
            "
            [attr.data-cy]="
              'sortable-section-header-' +
              sectionHeader?.headerName?.toLowerCase() +
              '-down-icon'
            "
            name="caret-down-outline"
          ></ion-icon>
        </div>
      </div>
    </ion-col>
  </ng-container>
</ion-row>

<!-- DATA -->
<ng-content></ng-content>

<!-- NO DATA -->
<ion-row
  *ngIf="!hasSectionData && !alternateDesign"
  data-cy="sortable-section-no-data-row"
  class="sortable-section-data-row"
>
  <ion-col data-cy="sortable-section-no-data-column" offset="0.25">
    <div data-cy="sortable-section-no-data-section" class="no-data">
      <p data-cy="sortable-section-no-data-text">
        {{ noDataText }}
      </p>
    </div>
  </ion-col>
</ion-row>
